import PaymentInstrumentModel from '../order/PaymentInstrumentModel';

/**
 * Represents CustomerPaymentInstrumentModel
 */
class CustomerPaymentInstrumentModel extends PaymentInstrumentModel {}

export default CustomerPaymentInstrumentModel;